import ReactGA from "react-ga4";
import Clarity from "@microsoft/clarity";

const GA_MEASUREMENT_ID = "G-YCBCC88ZXZ";
// const CLARITY_ID = "ev9dgg833d";
let ga_initialized = false;
// let clarity_initialized = false;

export const initGA = () => {
  const isProd = window.location.host.split(".")?.[0] === "elevate";

  if (GA_MEASUREMENT_ID && !ga_initialized) {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      testMode: isProd ? false : true,
    });
    // console.log('ReactGA', ReactGA)
    ga_initialized = true;
    console.log("Google Analytics initialized:");
    // Send initial page view
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  } else if (ga_initialized) {
    console.warn("Google Analytics already initialized.");
  } else {
    console.warn(
      "Google Analytics Measurement ID not found. GA not initialized."
    );
  }

  // if (CLARITY_ID && !clarity_initialized) {
  //   clarity_initialized = true;
  //   console.log("Clarity initialized:", CLARITY_ID);
  //   Clarity.init(CLARITY_ID);
  // } else if (clarity_initialized) {
  //   console.warn("Clarity already initialized.");
  // } else {
  //   console.warn("Clarity ID not found. Not initialized.");
  // }
};

export const trackPageView = (path) => {
  if (ga_initialized) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const trackEvent = (category, action, label) => {
  try {
    if (ga_initialized) {
      ReactGA.event({
        category: category,
        action: action,
        label: label, // optional
      });
    }
  } catch (e) {
    console.log(" GA event trigger error: ", e);
  }
};
